import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import VideoCard from "@/components/feature/VideoCard";
import Helmet from "@/components/base/Helmet";
import { videos, articles, categories } from "@/mocks/data";

const heroImages = [
  "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20city%20skyline%20at%20night%20with%20golden%20neon%20lights%2C%20dramatic%20clouds%2C%20warm%20amber%20and%20deep%20black%20tones%2C%20movie%20theater%20atmosphere%2C%20epic%20scale%2C%2021:9%20cinematic%20ratio%2C%20film%20grain%20texture%2C%20professional%20photography&width=1920&height=900&seq=douhua-hero-1&orientation=landscape",
  "https://readdy.ai/api/search-image?query=vintage%20film%20projector%20beam%20of%20light%20in%20dark%20room%2C%20dust%20particles%20floating%20in%20light%2C%20cinematic%20atmosphere%2C%20warm%20golden%20glow%2C%20classic%20movie%20theater%20vibe%2C%20rich%20amber%20and%20deep%20shadow%20contrast&width=1920&height=900&seq=douhua-hero-2&orientation=landscape",
  "https://readdy.ai/api/search-image?query=abstract%20flowing%20streams%20of%20golden%20and%20amber%20light%20against%20dark%20background%2C%20cinematic%20bokeh%20effect%2C%20warm%20glowing%20particles%2C%20elegant%20motion%20blur%2C%20luxurious%20atmosphere%2C%20film-like%20aesthetic&width=1920&height=900&seq=douhua-hero-3&orientation=landscape",
];

export default function Home() {
  const [currentHero, setCurrentHero] = useState(0);
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 6);
  const latestArticles = articles.slice(0, 4);

  const seoData = {
    title: "豆花视频 - 91视频97视频51视频免费在线观看电视剧全集 | 91在线视频网站高清不缓冲最新电影",
    description:
      "豆花视频为数字视频平台爱好者提供91视频、97视频、51视频免费在线观看，高清不缓冲，电视剧全集和最新电影一站直达。涵盖电视剧、电影、综艺、动漫、纪录片等丰富内容。",
    keywords: "豆花视频,91视频,97视频,51视频,91在线视频,免费在线观看,高清视频,最新电影,电视剧全集,数字视频平台",
    canonical: "https://douhuavideo.com",
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "豆花视频",
    url: "https://douhuavideo.com",
    description: seoData.description,
    potentialAction: {
      "@type": "SearchAction",
      target: "https://douhuavideo.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <Helmet
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical={seoData.canonical}
        ogTitle={seoData.title}
        ogDescription={seoData.description}
        ogType="website"
        scriptLd={structuredData}
      />

      <div className="min-h-screen bg-gray-950">
        <Navbar />

        {/* Hero Section */}
        <section className="relative h-[420px] md:h-[600px] overflow-hidden">
          {heroImages.map((img, i) => (
            <div
              key={i}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                i === currentHero ? "opacity-100" : "opacity-0"
              }`}
            >
              <img
                src={img}
                alt={`豆花视频 Hero ${i + 1}`}
                className="w-full h-full object-cover object-top"
                width={1920}
                height={900}
              />
            </div>
          ))}
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-gray-950"></div>

          <div className="absolute bottom-0 left-0 right-0 flex justify-center gap-2 pb-6">
            {heroImages.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentHero(i)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  i === currentHero ? "bg-amber-400 w-6" : "bg-white/40 hover:bg-white/60"
                }`}
              />
            ))}
          </div>

          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-2xl md:text-5xl font-bold text-white mb-4 leading-tight max-w-3xl">
              91视频 · 97视频 · 51视频
              <br />
              <span className="text-amber-400">免费在线观看</span>，高清不缓冲
            </h1>
            <p className="text-sm md:text-base text-gray-300 max-w-2xl mb-8 leading-relaxed">
              电视剧全集、最新电影一站直达，涵盖电视剧、电影、综艺、动漫、纪录片等海量内容，
              每天更新，随时随地畅享高清观影体验
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <Link
                to="/category/dianshiju"
                className="px-6 py-2.5 bg-amber-500 hover:bg-amber-400 text-black font-semibold text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-1.5"></i>
                开始观看
              </Link>
              <Link
                to="/category/dianying"
                className="px-6 py-2.5 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-full border border-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-movie-line mr-1.5"></i>
                热门电影
              </Link>
            </div>
          </div>

          <button
            onClick={() => setCurrentHero((currentHero + 1) % heroImages.length)}
            className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
          <button
            onClick={() => setCurrentHero((currentHero - 1 + heroImages.length) % heroImages.length)}
            className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
        </section>

        {/* Category Quick Nav */}
        <section className="w-full px-4 md:px-6 -mt-8 relative z-20">
          <div className="max-w-5xl mx-auto">
            <div className="bg-gray-900/90 backdrop-blur-md border border-gray-800/50 rounded-2xl p-3 md:p-4">
              <div className="grid grid-cols-5 gap-2 md:gap-3">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex flex-col items-center gap-1.5 py-3 md:py-4 rounded-xl hover:bg-gray-800/70 transition-all duration-200 group cursor-pointer"
                  >
                    <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-amber-500/10 text-amber-400 group-hover:bg-amber-500 group-hover:text-black transition-all duration-200">
                      <i className={`${cat.icon} text-lg md:text-xl`}></i>
                    </div>
                    <span className="text-xs md:text-sm text-gray-300 group-hover:text-white transition-colors whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Hot Videos */}
        <section className="w-full px-4 md:px-6 pt-12 md:pt-16 pb-8">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="text-lg md:text-2xl font-bold text-white">
                  <i className="ri-fire-line text-amber-400 mr-2"></i>
                  热门推荐
                </h2>
                <p className="text-xs md:text-sm text-gray-400 mt-1">大家都在看的精彩内容</p>
              </div>
              <Link
                to="/category/dianshiju"
                className="text-xs md:text-sm text-amber-400 hover:text-amber-300 transition-colors flex items-center gap-0.5 whitespace-nowrap"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {hotVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>
        </section>

        {/* Category Sections */}
        {categories.slice(0, 2).map((cat) => {
          const catVideos = videos.filter((v) => v.category === cat.slug).slice(0, 6);
          return (
            <section key={cat.slug} className="w-full px-4 md:px-6 py-8">
              <div className="max-w-7xl mx-auto">
                <div className="flex items-center justify-between mb-6 md:mb-8">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-xl bg-amber-500/10 text-amber-400">
                      <i className={`${cat.icon} text-base md:text-lg`}></i>
                    </div>
                    <div>
                      <h2 className="text-lg md:text-xl font-bold text-white">{cat.name}</h2>
                      <p className="text-xs text-gray-400 mt-0.5">精选{cat.name}内容</p>
                    </div>
                  </div>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-xs md:text-sm text-amber-400 hover:text-amber-300 transition-colors flex items-center gap-0.5 whitespace-nowrap"
                  >
                    全部 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
                  {catVideos.map((video) => (
                    <VideoCard key={video.id} video={video} />
                  ))}
                </div>
              </div>
            </section>
          );
        })}

        {/* Latest Articles */}
        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="text-lg md:text-2xl font-bold text-white">
                  <i className="ri-article-line text-amber-400 mr-2"></i>
                  最新资讯
                </h2>
                <p className="text-xs md:text-sm text-gray-400 mt-1">影视动态与观影指南</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group block rounded-xl overflow-hidden bg-gray-900/80 border border-gray-800/50 hover:border-amber-500/50 transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={article.cover}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      width={800}
                      height={450}
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-medium text-white line-clamp-2 group-hover:text-amber-400 transition-colors leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-xs text-gray-400 mt-2 line-clamp-2 leading-relaxed">
                      {article.summary}
                    </p>
                    <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-800/50">
                      <span className="text-[10px] text-gray-500">{article.publishDate}</span>
                      <span className="text-[10px] text-gray-500 flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.viewCount > 10000
                          ? `${(article.viewCount / 10000).toFixed(1)}万`
                          : article.viewCount}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-7xl mx-auto">
            <div className="relative rounded-2xl overflow-hidden bg-gradient-to-r from-amber-600/20 via-orange-600/10 to-amber-600/20 border border-amber-500/20 p-8 md:p-12 text-center">
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-500/10 via-transparent to-transparent"></div>
              <div className="relative z-10">
                <h2 className="text-xl md:text-3xl font-bold text-white mb-3">
                  海量高清视频，免费在线观看
                </h2>
                <p className="text-sm md:text-base text-gray-300 max-w-xl mx-auto mb-6">
                  91视频、97视频、51视频等精品内容持续更新，
                  高清不缓冲，随时随地享受观影乐趣
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/dianshiju"
                    className="px-6 py-2.5 bg-amber-500 hover:bg-amber-400 text-black font-semibold text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    立即观看
                  </Link>
                  <Link
                    to="/about"
                    className="px-6 py-2.5 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-full border border-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    了解更多
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}